import clsx from "clsx";

export type BarChartSize = "small" | "medium";

export type BarChartData = {
  count: number;
  label: string;
  color: string;
};

export type Props = {
  data: BarChartData[];
  size?: BarChartSize;
  barClassName?: string;
  itemClassName?: string;
  showLabel?: boolean;
};

export const BarChart = ({
  data,
  size = "small",
  barClassName,
  itemClassName,
  showLabel = false,
}: Props) => {
  const totalCount = data.reduce((acc, item) => acc + item.count, 0);
  const filteredData = data.filter((item) => item.count > 0);

  return (
    <div className="flex flex-col gap-2.5 text-white text-xs">
      <div
        className={clsx("flex", barClassName, {
          "h-[16px]": size === "small",
          "h-[25px]": size === "medium",
        })}
      >
        {filteredData.map((item, index) => {
          const percent = Math.round((item.count / totalCount) * 100);

          return (
            <div
              key={index}
              className={clsx(
                "flex justify-center items-center w-full h-full",
                item.color,
                itemClassName,
                {
                  "rounded-l-[3px]": index === 0 || percent === 100,
                  "rounded-r-[3px]":
                    index === filteredData.length - 1 || percent === 100,
                }
              )}
              style={{ width: `${percent}%`, boxSizing: "border-box" }}
            >
              {percent}%
            </div>
          );
        })}
      </div>

      {showLabel && (
        <div className="flex flex-col">
          {data.map((item, index) => (
            <div
              key={index}
              className="flex gap-[14px] items-center py-[13px] border-b border-brand-primary-gray-10"
            >
              <span
                className={clsx("rounded-[4px] w-[14px] h-[14px]", item.color)}
              />
              <div className="text-sm text-black">
                <span className="text-brand-neutral-60">{item.label} :</span>
                {` ${item.count}명`}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
